import Vue from 'vue'
import Router from 'vue-router'
//引入setWechatTitle动态改变Title
import setWechatTitle from '@/utils/setWechatTitle'

//导入路由map
// import routes from './map'
import activity from '@/views/activity/router'
import user from '@/views/user/router'
import home from '@/views/home/router'
import report from '@/views/report/router'
import order from '@/views/order/router'
import trade from '@/views/trade/router'
import hospital from '@/views/hospital/router'
import errorPage from '@/views/error/router'
import question from '@/views/question/router'
import medicineChinese from '@/views/medicineChinese/router'
import healthyCoin from '@/views/healthy-coin/router'
import healthdoc from '@/views/healthdoc/router'
import device from '@/views/device/router'
import invoice from '@/views/invoice/router'
import healthManage from '@/views/health-manage/router'
import doctorStudio from '@/views/doctorStudio/router'
import associationManage from '@/views/association-manage/router'
import evaluation from '@/views/evaluation/router'
import robotChat from '@/views/robot-chat/router'
//import axios from 'axios'
import store from '@/store'
import weChat from '@/utils/wxAuthorization'

import { setCookie, getCookie, delCookie, GetUrlParam } from '@/utils/tools'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path:'*',
      redirect:'/error/404'
    },
    {
      path:'/',
      redirect: '/home/main'
    },
    activity,
    user,
    home,
    report,
    order,
    trade,
    hospital,
    question,
    errorPage,
    medicineChinese,
    healthyCoin,
    healthdoc,
    device,
    invoice,
    healthManage,
    doctorStudio,
    associationManage,
    evaluation,
    robotChat
  ]
  // mode: 'history'
})

router.beforeEach((to, from, next) => {
  // ----------------- 绑定硬件设备相关  start -------------------------
  // 设备模块页面 (由于不仅仅只是从首页进入 有多个入口故只要没有code或openId就去授权页)
  if (to.matched[0].name === 'device') {
    //将设备公众号的appid存储到cookie中
    let deviceAppId = to.query.deviceAppId
    let cookieDeviceAppid = getCookie('deviceAppId')
    if (deviceAppId) {
      // 参数的appid跟cookie中存储的appid不同，则清除openid信息
      if (deviceAppId !== cookieDeviceAppid) {
        store.commit('setDeviceOpenId', '')
      }
      setCookie('deviceAppId', deviceAppId)
    } else {
      if (!cookieDeviceAppid) {
        store.commit('setDeviceOpenId', '')
        setCookie('deviceAppId', process.env.DEVICE_APPID)
      }
    }

    // 路由和vuex中取openId
    let openId = to.query.openId || store.getters.deviceOpenId
    // url中取code
    let code = weChat.getUrlStr('code')

    // 没有openId和code 去授权页
    if (!openId && !code) {
      if (to.name !== 'DeviceAuthorization') {
        // 跳授权页 带上跳转前的path
        // eslint-disable-next-line
        next({
          path: '/device/authorization',
          query: { path: to.path }
        })
      }
    }
  }
  // ----------------- 绑定硬件设备相关  end ---------------------------

  // 微信小程序web-view内嵌h5页面通过url传token即存入cookie(共享登录状态)
  let { WEB_VIEW_TOKEN } = to.query

  if (WEB_VIEW_TOKEN) {
    setCookie('Authorization', WEB_VIEW_TOKEN)
  }
  // 加项页面拦截器，加项页面只能从套餐详情和提交订单页面进入，否则强制跳转到套餐详情页面
  if (to.name === 'add-item' && (from.name !== 'meal-detail' && from.name !== 'appointment')) {
    // eslint-disable-next-line
    next({ name: 'meal-detail', params: to.params })
  }
  if (location.href.indexOf('?shareTarget=') !== -1) {
    // eslint-disable-next-line
    let href = location.href.split('?shareTarget=')[0] + '#' + decodeURIComponent(location.href.split('?shareTarget=')[1].split('&')[0])

    location.href = href
  } else {
    /**
     * 动态改变页面的title值
     */
    document.title = to.meta.title
    setWechatTitle(to.meta.title)
    // 区分公众号类型
    // 医院公众号标识: hospital
    // 自有公众号标识: touchealth
    if (typeof to.query.gzhType !== 'undefined') {
      // 页面首次加载
      setCookie('gzhType', to.query.gzhType)
    } else if (typeof from.query.gzhType !== 'undefined') {
      // 全局路由携带类型
      to.query.gzhType = from.query.gzhType
      setCookie('gzhType', to.query.gzhType)
    } else if (typeof getCookie('gzhType') !== 'undefined') {
      // 防止刷新 路由信息丢失
      to.query.gzhType = getCookie('gzhType').toString()
      setCookie('gzhType', to.query.gzhType)
    } else {
      // 默认公众号类型
      to.query.gzhType = 'touchealth'
      setCookie('gzhType', to.query.gzhType)
    }
    // 医院公众号，存储医院id
    if (typeof getCookie('hosId') === 'undefined' || to.query.gzhType === 'hospital') {
      let hosId = from.params.hid || from.params.hosId || from.query.hid || from.query.hosId || from.query.hospitalId || to.params.hid || to.params.hosId || to.query.hid || to.query.hospitalId || to.query.hosId

      if (typeof hosId !== 'undefined') {
        to.query.hosId = hosId
        setCookie('hosId', hosId)
      } else {
        let params = new GetUrlParam()

        to.query.hosId = params.hosId
        setCookie('hosId', hosId)
      }
    } else if (to.query.gzhType === 'touchealth' && typeof getCookie('hosId') !== 'undefined') {
      delCookie('hosId')
    }

    //公众号推广统计
    if (typeof to.query.msId === 'undefined' || typeof getCookie('msId') === 'undefined'){
      let msId = from.params.msId || from.query.msId || to.params.msId || to.query.msId

      if (typeof msId !== 'undefined') {
        to.query.msId = msId
        setCookie('msId', msId)
      }
    }
    if (typeof to.query.channelId === 'undefined' || typeof getCookie('channelId') === 'undefined'){
      let channelId = from.params.channelId || from.query.channelId || to.params.channelId || to.query.channelId

      if (typeof channelId !== 'undefined') {
        to.query.channelId = channelId
        setCookie('channelId', channelId)
      }
    }
    //销售二维码推广统计（销售对应下单的统计）
    if (typeof to.query.saleman === 'undefined' || typeof getCookie('saleman') === 'undefined'){
      let saleman = from.params.saleman || from.query.saleman || to.params.saleman || to.query.saleman
      if (typeof saleman !== 'undefined') {
        to.query.saleman = saleman
        setCookie('saleman', saleman)
      }
    } else {
      setCookie('saleman', to.query.saleman)
    }
    //公众号推广图文点击量统计
    // let messId = from.params.msId || from.query.msId || to.params.msId || to.query.msId || getCookie('msId')
    // let chanId = from.params.channelId || from.query.channelId || to.params.channelId || to.query.channelId || getCookie('channelId')
    //
    // if (messId && chanId){
    //   //未登录用户
    //   //eslint-disable-next-line
    //   let url = window.location.origin + to.path
    //   if (typeof(getCookie('link')) === 'undefined') {
    //     //第一次点击图文
    //     axios.post( process.env.API_ROOT + '/common/not-login/message-statistics',
    //       {
    //         messageId: messId,
    //         channelId: chanId
    //       }
    //     )
    //       .then(function (response) {
    //         //eslint-disable-next-line
    //         console.log(response)
    //         if (response.data.rc === 0) {
    //           setCookie('link', url)
    //         }
    //       })
    //       .catch(function (error) {
    //         //eslint-disable-next-line
    //         console.log(error)
    //       })
    //   } else if (getCookie('link') === url) {
    //     axios.post( process.env.API_ROOT + '/common/not-login/message-statistics',
    //       {
    //         messageId: messId,
    //         channelId: chanId
    //       }
    //     )
    //       .then(function (response) {
    //         //eslint-disable-next-line
    //         console.log(response)
    //         if (response.data.rc === 0) {
    //           setCookie('link', url)
    //         }
    //       })
    //       .catch(function (error) {
    //         //eslint-disable-next-line
    //         console.log(error)
    //       })
    //   }
    //   if (getCookie('Authorization')){
    //     //已登录用户
    //     axios.post( process.env.API_ROOT + '/user/message-statistics',
    //       {
    //         messageId: messId,
    //         channelId: chanId
    //       },
    //       {
    //         headers: {
    //           'Authorization': getCookie('Authorization')
    //         }
    //       }
    //     )
    //       .then(function (response) {
    //         if (response.data.rc === 0) {
    //           //eslint-disable-next-line
    //           console.log(response)
    //         }
    //       })
    //       .catch(function (error) {
    //         //eslint-disable-next-line
    //         console.log(error)
    //       })
    //   }
    // }
    if (from.name === 'Video' && to.name === 'meal-detail') {
      // 判断从秒懂中心后退至套餐详情页 页面回到指定位置
      setTimeout(()=>{
        document.documentElement.scrollTop = from.query.scrollTo
        document.body.scrollTop = from.query.scrollTo
      }, 100)
    } else {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }
    // eslint-disable-next-line
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js